var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 37,
    rx: 4,
    fill: "#271969"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20V27L9 19L17 11V18H25V20H17Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/back-arrow.043b9dcf1d36bb636d12d53ab19ca1c0.svg";